export default __webpack_public_path__ + "static/media/NL_parcours_2_carte_1.03f15ced.png";